import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type SetPerksWaitingPeriodRequest = {
  productClassId: string
  waitingPeriod: number
}

const setPerksWaitingPeriod = (request: SetPerksWaitingPeriodRequest): Promise<void> => {
  return adminHttpClient.post('/AdminDashboard/Perks/ClassDesign/SetWaitingPeriod', request)
}

export default setPerksWaitingPeriod
